import React, { useEffect } from "react";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

const BG = "https://images.unsplash.com/photo-1597407068889-782ba11fb621?crop=entropy&cs=srgb&fm=jpg&q=85&w=1920";

export default function NotFound() {
  useEffect(() => {
    const prevTitle = document.title;
    document.title = "Page introuvable — HorsSignal";
    const robots = document.createElement("meta");
    robots.name = "robots";
    robots.content = "noindex, nofollow";
    document.head.appendChild(robots);
    const status = document.createElement("meta");
    status.name = "prerender-status-code";
    status.content = "404";
    document.head.appendChild(status);
    return () => {
      document.title = prevTitle;
      document.head.removeChild(robots);
      document.head.removeChild(status);
    };
  }, []);

  return (
    <section
      data-testid="not-found-page"
      className="relative min-h-screen flex items-center overflow-hidden"
    >
      {/* Visuel immersif */}
      <div className="absolute inset-0">
        <img src={BG} alt="" className="w-full h-full object-cover grayscale opacity-40" />
        <div className="absolute inset-0 bg-gradient-to-b from-[#0A0A0A] via-[#0A0A0A]/70 to-[#0A0A0A]" />
        <div className="absolute inset-0" style={{ background: "radial-gradient(circle at 50% 40%, rgba(188,93,46,0.14), transparent 60%)" }} />
      </div>

      {/* Chiffre fantôme */}
      <span aria-hidden="true" className="pointer-events-none select-none absolute inset-0 flex items-center justify-center font-clash font-bold text-[38vw] leading-none text-white/[0.04] tracking-tighter">
        404
      </span>

      <div className="relative mx-auto max-w-4xl px-6 sm:px-12 py-32 text-center">
        <span className="font-mono-hs text-[11px] uppercase tracking-[0.35em] text-[#BC5D2E]">// Signal perdu · 404</span>
        <h1 className="font-clash font-bold text-5xl sm:text-6xl lg:text-7xl uppercase tracking-tighter mt-6 leading-[0.95]">
          Vous êtes allé<br />trop loin.
        </h1>
        <p className="text-[#A3A3A3] text-base sm:text-lg mt-6 max-w-xl mx-auto">
          La page que vous recherchez n'existe pas ou n'est plus disponible.
        </p>
        <div className="mt-10 flex justify-center">
          <Link
            to="/"
            data-testid="notfound-home-btn"
            className="group inline-flex items-center gap-3 bg-[#BC5D2E] text-white px-8 py-4 uppercase tracking-widest text-sm hover:bg-[#8A281E] transition-colors"
          >
            <ArrowLeft size={16} className="group-hover:-translate-x-1 transition-transform" />
            Retour vers l'accueil
          </Link>
        </div>
      </div>
    </section>
  );
}
